import './404.css';
const NotFound=()=> {
 
    //  this.newEvent = this.newEvent.bind(this);
     // this.handleEvent = this.handleEvent.bind(this);
     const handleEvent=()=> 
      {
        window.location.href="/"
  
      }
      const newEvent=(val)=>  
      {
        alert(val);
      }
   
  
      return (
        <div class="container404">
        <h1>Oops!</h1>
        <h3>404 - PAGE NOT FOUND</h3>
        <p>The page you are looking for might be removed or temporarily unavailable</p>
        <button onClick={handleEvent}>GOTO HOMEPAGE</button>
    </div>
    )
  
    
  }
  
  export default NotFound;